var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"4a72e37f8374b31a15507c0031d5ef7642c4af61"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["react-token-launch@giddy"]={id:"4a72e37f8374b31a15507c0031d5ef7642c4af61"};
      